export class TransportCounter {
    public currentMonthCounter: number;
    public previousMonthCounter: number;
    public currentMonthQuantity: number;
    public previousMonthQuantity: number;
    constructor(transportCounter?: TransportCounter) {
        this.currentMonthCounter = transportCounter?.currentMonthCounter || 0;
        this.previousMonthCounter = transportCounter?.previousMonthCounter || 0;
        this.currentMonthQuantity = transportCounter?.currentMonthQuantity || 0;
        this.previousMonthQuantity = transportCounter?.previousMonthQuantity || 0;
    }
}

